import { createRpcFetcher as _createRpcFetcher } from "next-rpc/dist/browser";
export var createStripeCheckoutSession = /*#__PURE__*/ _createRpcFetcher("/api/stripe", "createStripeCheckoutSession");
export var createStripePortal = /*#__PURE__*/ _createRpcFetcher("/api/stripe", "createStripePortal");
